import * as Yup from 'yup';

export const startupCrudFormSchema = Yup.object().shape({
    committedAmount: Yup.number().required('Required'),
});